module.exports = __webpack_public_path__ + "img/purple.dcdc066d.webp";